import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c(VTextField,{staticClass:"input-group--focused",attrs:{"label":_vm.field.description,"clearable":"","hide-details":""},model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }